import React from 'react';

const BRAND_ORANGE = '#F47518';

export default function PerfectForSection({ items = [] }) {
  if (!items.length) return null;

  return (
    <section aria-labelledby="perfect-for-heading">
      <h2 id="perfect-for-heading" className="text-xl font-bold text-foreground mb-3">
        Perfect For
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-1.5">
        {items.map((item) => (
          <div key={item.label} className="flex items-start gap-2 text-sm text-foreground font-normal">
            <span className="shrink-0 font-bold" style={{ color: BRAND_ORANGE }}>•</span>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
